import angular from 'angular';
import uiRouter from 'angular-ui-router';
import myLoansRequestCadastralComponent from './myLoansRequestCadastral.component';

let myLoansRequestCadastralModule = angular.module('myLoansRequestCadastral', [
  uiRouter
])

.component('myLoansRequestCadastral', myLoansRequestCadastralComponent)

.name;

export default myLoansRequestCadastralModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansRequestCadastral/myLoansRequestCadastral.js